import { render, staticRenderFns } from "./NewsCardCompany.vue?vue&type=template&id=5dc68d29&scoped=true&"
import script from "./NewsCardCompany.vue?vue&type=script&lang=js&"
export * from "./NewsCardCompany.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardCompany.vue?vue&type=style&index=0&id=5dc68d29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc68d29",
  null
  
)

export default component.exports